
import IMG1 from '../../assests/portfolio1__.jpg';
import IMG2 from '../../assests/portfolio2_.jpg';
import IMG3 from '../../assests/portfolio3_.jpg';
import IMG4 from '../../assests/rastaurant.jpg';
import IMG5 from '../../assests/portfolio5.jpeg';
import IMG6 from '../../assests/portfolio6.jpg';



export const data= [ 
    {
    id: 1,
    title: "TaskMaster",
    img: IMG1,
    Github: "https://github.com/Ashishtorq/TaskMaster",
    demo: "https://6485a98418fa9405df4ad84d--stellular-baklava-1b93c6.netlify.app/",
    },
    {
    id: 2,
    title: "Portfolio Website",
    img: IMG2,
    Github: "https://github.com/Ashishtorq/My-Portfolio",
    demo: "",
    },
    {
    id: 3,
    title: "Weather App",
    img: IMG3,
    Github: "https://github.com/Ashishtorq/WeatherWise",
    demo: "https://weather-wise-ashish.vercel.app/",
    },
    {
    id: 4,
    title: "Restaurant Web-App",
    img: IMG4,
    Github: "https://github.com/Ashishtorq/Food-For-Foodies/tree/master",
    demo: "https://food-for-foodie.netlify.app/",
    },
    {
    id: 4,
    title: "Fit-Fusion (Gym Website)",
    img: IMG5,
    Github: "https://github.com/Ashishtorq/FitFusion",
    demo: "https://wondrous-profiterole-ec81d2.netlify.app/",
    },
    // {
    //   id: 4,
    //   title: "Fit-Fusion (Gym Website)",
    //   img: IMG5,
    //   Github: "https://github.com/Ashishtorq/FitFusion",
    //   demo: "https://wondrous-profiterole-ec81d2.netlify.app/",
    //   },
   
    
  ]
